
  import { Component, Mixins, Prop } from "vue-property-decorator";
  import AuthMixin from "@/common/mixins/auth.mixin";
  import { mapState } from "vuex";
  import { OfficeProfileDto } from "@/types/office.type";

  @Component({
    computed: {
      ...mapState("OfficeProfile", ["officeProfiles"])
    }
  })
  export default class PaymentInfoModal extends Mixins(AuthMixin) {
    @Prop({ required: true }) officeId!: number;
    @Prop({ required: true }) hasNextShift!: boolean;

    officeProfiles!: OfficeProfileDto[];

    loading = false;

    async toEditSubscription(): Promise<void> {
      this.loading = true;

      await this.$store.dispatch("OfficeProfile/getOfficeProfiles", this.userInfo()?.practiceId);

      this.$store.commit("OfficeProfile/updateField", {
        path: "selectedOffice",
        value: this.officeProfiles.find(profile => profile.id === this.officeId)
      });

      this.$store.commit("OfficeProfile/updateField", {
        path: "isEdit",
        value: true
      });
      
      this.$router.push({ path: "/office-profiles-edit", query: { activeTab: "5" } });
    }
  }
